'use client';

import { useSearchParams } from 'next/navigation';
import { ReactNode, useEffect, useState } from 'react';

import {
  FONT_VARIABLE_CLASSES,
  getFontClasses,
} from '@/lib/utils/getFontClasses';

interface Props {
  children: ReactNode;
  defaultTheme: string;
  allowThemeOverride: boolean;
}

export default function ThemeProvider({
  children,
  defaultTheme,
  allowThemeOverride,
}: Props) {
  const searchParams = useSearchParams();
  const [theme, setTheme] = useState<string>(defaultTheme);

  // Only in development or explicitly enabled environments
  useEffect(() => {
    if (allowThemeOverride) {
      const query = searchParams.get('theme');
      if (query) setTheme(query);
    }
  }, [allowThemeOverride, searchParams]);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;

    const fontClasses = getFontClasses(theme).split(' ').filter(Boolean);
    document.documentElement.classList.remove(...FONT_VARIABLE_CLASSES);
    document.documentElement.classList.add(...fontClasses);
  }, [theme]);

  return <>{children}</>;
}
